import BaseBadge from '@material-ui/core/Badge'

const Badge = BaseBadge

export default Badge
